import type { TranslatedString } from "../types"

export const weekdays: Record<string, TranslatedString> = {
  sunday: { text: "Sunday", translation: "Dé Domhnaigh" },
  monday: { text: "Monday", translation: "Dé Luain" },
  tuesday: { text: "Tuesday", translation: "Dé Máirt" },
  wednesday: { text: "Wednesday", translation: "Dé Céadaoin" },
  thursday: { text: "Thursday", translation: "Déardaoin" },
  friday: { text: "Friday", translation: "Dé hAoine" },
  saturday: { text: "Saturday", translation: "Dé Sathairn" },
}

export const months: Record<string, TranslatedString> = {
  january: { text: "January", translation: "Eanáir" },
  february: { text: "February", translation: "Feabhra" },
  march: { text: "March", translation: "Márta" },
  april: { text: "April", translation: "Aibreán" },
  may: { text: "May", translation: "Bealtaine" },
  june: { text: "June", translation: "Meitheamh" },
  july: { text: "July", translation: "Iúil" },
  august: { text: "August", translation: "Lúnasa" },
  september: { text: "September", translation: "Meán Fómhair" },
  october: { text: "October", translation: "Deireadh Fómhair" },
  november: { text: "November", translation: "Samhain" },
  december: { text: "December", translation: "Nollaig" },
}

const weekdayKeys = Object.keys(weekdays)
const monthKeys = Object.keys(months)

/**
 * Get weekday translation from day index (0 = Sunday, 6 = Saturday)
 */
export function weekdayFromInt(index: number): TranslatedString {
  return weekdays[weekdayKeys[index]]
}

/**
 * Get month translation from month index (0 = January, 11 = December)
 */
export function monthFromInt(index: number): TranslatedString {
  return months[monthKeys[index]]
}
